import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import configureAxios from './utils/axiosConfig';

// Configure axios for API integration
configureAxios();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
